import request from '@/utils/request'

export function getDistrictOpt() {
    return request({
        url: '/wwqb/dict/area-tree',
        method: 'get'
    })
}

export function getQuestionSourceOpt() {
    return request({
        url: '/stage4/wwqb/home/book-type/combo-box',
        method: 'get'
    })
}

export function getCatalogOpt() {
    return request({
        url: '/stage4/wwqb/home/catalog/combo-box',
        method: 'get'
    })
}

export function searchOpt(data){
    let url = '/stage4/wwqb/home/region/list?';
    if(data.areaId){
      url = url + '&areaId=' + data.areaId;
    }
    if(data.bookType){
      url = url + '&bookType=' + data.bookType;
    }
    if(data.catalogType){
      url = url + '&catalogType=' + data.catalogType;
    }
    return request({
      url: url,
      method: 'get',
    })
  }

export function addOrEditDistrict(data){
  return request({
    url: '/stage4/wwqb/home/region/edit',
    method: 'post',
    data: data
  })
}

export function getGuideOpt(data) {
  return request({
      url: '/stage4/wwqb/home/guide/list?regionId=' + data.regionId,
      method: 'get'
  })
}


export function saveGuideOpt(data){
  return request({
    url: '/stage4/wwqb/home/guide/edit',
    method: 'post',
    data: data
  })
}

export function updateDistrictStatus(data){
  return request({
    url: '/stage4/wwqb/home/region/status/switch',
    method: 'post',
    data: data
  })
}

export function createQuestionOpt(data){
  return request({
    url: '/stage4/wwqb/home/book/edit',
    method: 'post',
    data: data
  })
}

export function updateQuestionStatusOpt(data){
  return request({
    url: '/stage4/wwqb/home/book/status/switch',
    method: 'post',
    data: data
  })
}

export function deleteBook(data){
  return request({
    url: `/stage5/wwqb/home/sp/book/del?bookId=${data.bookId}`,
    method: 'delete',
  })
}

export function deleteRegion(data){
  return request({
    url: `/stage5/wwqb/home/sp/region/del?regionId=${data.regionId}`,
    method: 'delete',
  })
}

export function deleteCatalog(data){
  return request({
    url: `/stage5/wwqb/home/sp/catalog/del?catalogId=${data.catalogId}`,
    method: 'delete',
  })
}

export function updateCatalogStatusOpt(data){
  return request({
    url: '/stage4/wwqb/home/catalog/status/switch',
    method: 'post',
    data: data
  })
}

export function addTestLevel(data){
  return request({
    url: '/stage4/wwqb/exam-paper/lvl/add',
    method: 'post',
    data: data
  })
}

export function delTestLevel(id) {
    return request({
        url: `/stage4/wwqb/exam-paper/lvl/delete?id=${id}`,
        method: 'delete'
    })
}

export function renameTestLevel(data){
  return request({
    url: '/stage4/wwqb/exam-paper/lvl/rename',
    method: 'post',
    data: data
  })
}

export function getTestLevelTree(id) {
    return request({
        url: `/stage4/wwqb/exam-paper/lvl/tree?bookCatalogId=${id}`,
        method: 'get'
    })
}

export function updateModuleInfo(data) {
  return request({
      url: `/stage4/wwqb/exam-paper/catalog/edit`,
      method: 'post',
      data:data
  })
}